import React from 'react';
import Loader from './Loader';
import PageMessage from './PageMessage';
import Text from './Typography';

type Props = {
  title: string,
  subtitle: string,
  className: string,
  fullWidth: boolean,
  loading: boolean,
  cta: any,
  headerContentRight: any,
  children: any,
  error?: string,
  icon?: string,
  iconSize?: string
}


const PageSection = (props: Props) => {
  return (
    <div className={`section ${props.className}`}>
      <div>
        <nav className='section__header'>

          <div className='section__header__sub-container'>
            <Text h1 icon={props.icon} iconSize={props.iconSize} className='section__header__title'>
              {props.title}
            </Text>
            <Text h3 className='section__header__sub-title'>
              {props.subtitle}
            </Text>
          </div>

          {props.headerContentRight && (
            <div className='section__header__sub-container'>
              {props.headerContentRight}
            </div>
          )}
        </nav>

        <div className='section__content'>
          {props.loading && <Loader />}
          {props.error && <PageMessage body={props.error} />}
          {props.children}
        </div>
      </div>
    </div>
  );
};
export default PageSection;




// WEBPACK FOOTER //
// ./src/components/shared/PageSection.js